import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import _ from 'lodash';
import { AccountTypeOptionItemTagType, E_AcvType } from '@/apis/service/CompanyApi.types';
export var E_AcvAndArr;
(function (E_AcvAndArr) {
    E_AcvAndArr["ACV"] = "ACV";
    E_AcvAndArr["ARR"] = "ARR";
})(E_AcvAndArr || (E_AcvAndArr = {}));
let CustomerService = class CustomerService {
    constructor(i18n, SystemService) {
        this.i18n = i18n;
        this.SystemService = SystemService;
    }
    acvCnMap(type = E_AcvAndArr.ACV) {
        return [{
                label: `${type} < 0`,
                value: E_AcvType.ACV_UNLIMITED_0,
            }, {
                label: `${type} = 0`,
                value: E_AcvType.NA,
            },
            {
                label: `0 <  ${type}  < ￥50,000`,
                value: E_AcvType.ACV_0_50000,
            },
            {
                label: `￥50,000 ≤  ${type}  < ￥100,000`,
                value: E_AcvType.ACV_50000_100000,
            },
            {
                label: `${type} ≥ ￥100,000`,
                value: E_AcvType.ACV_100000_UNLIMITED,
            }];
    }
    acvEuMap(type = E_AcvAndArr.ACV) {
        return [
            {
                label: `${type} < 0`,
                value: E_AcvType.ACV_UNLIMITED_0,
            },
            {
                label: `${type} = 0`,
                value: E_AcvType.NA,
            },
            {
                label: `0 < ${type} < $50,000`,
                value: E_AcvType.ACV_0_50000,
            },
            {
                label: `${type} ≥ $50,000`,
                value: E_AcvType.ACV_50000_UNLIMITED,
            }
        ];
    }
    get acvThisYear() {
        return this.SystemService.IsCn
            ? this.acvCnMap()
            : this.acvEuMap();
    }
    accountTypeEastOptions() {
        return [{
                label: this.i18n.t('backoffice.globalView.accountTypes.customer'),
                value: 'Customer',
                tag_type: AccountTypeOptionItemTagType.SUCCESS,
            }, {
                label: this.i18n.t('backoffice.globalView.accountTypes.prospect'),
                value: 'Prospect',
            }];
    }
    accountTypeWestOptions() {
        // west account type 无需翻译
        return [{
                label: 'Customer',
                value: 'Customer',
                tag_type: AccountTypeOptionItemTagType.SUCCESS,
            }, {
                label: 'Prospect',
                value: 'Prospect',
                tag_type: AccountTypeOptionItemTagType.SUCCESS,
            }, {
                label: 'Partner',
                value: 'Partner',
            }, {
                label: 'No longer trading',
                value: 'No longer trading',
            }, {
                label: 'Not Contact',
                value: 'DO NOT CONTACT - Already a customer',
            }, {
                label: 'Others',
                value: 'Others',
            }];
    }
    get accountTypeOptions() {
        return this.SystemService.IsCn ? this.accountTypeEastOptions() : this.accountTypeWestOptions();
    }
    transformAcv(currency, acv, type = E_AcvAndArr.ACV) {
        const acvMap = currency === 'CNY' ? this.acvCnMap(type) : this.acvEuMap(type);
        return _.find(acvMap, item => item.value === acv)?.label || `${type} = 0`;
    }
};
CustomerService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.SystemService)),
    __metadata("design:paramtypes", [Object, Object])
], CustomerService);
export { CustomerService };
